import { render } from "./HistoryPanel.vue?vue&type=template&id=5f3ccb91&scoped=true"
import script from "./HistoryPanel.vue?vue&type=script&lang=ts"
export * from "./HistoryPanel.vue?vue&type=script&lang=ts"

import "./HistoryPanel.vue?vue&type=style&index=0&id=5f3ccb91&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f3ccb91"

export default script